/**
 * Иконки «Селлер-Штаба» (C:/tmp/rebrand/06-icons.md, агент «Иконки»).
 *
 * Пути — точные исходники lucide-static 1.55.0, скопированы без изменений генератором make_tsx.py.
 * Лицензия: ISC © Lucide Icons and Contributors; иконки, взятые Lucide из Feather (check, chevron-*, x, lock…),
 * — ещё и MIT © Cole Bemis. Полный текст — LICENSE рядом с этим файлом, в релиз кладётся целиком.
 * Руками пути не править: обновление — перегенерацией.
 * Зависимостей нет, кроме React. В коде экранов используются только РОЛИ (tab-summary,
 * status-fine…), а не имена Lucide: так иконку роли меняют в одном месте.
 * ⛔ Эмодзи в роли иконок («❗», «←», «›») не используем: только этот набор.
 */
import { createElement } from 'react'

type Tag = 'path' | 'circle' | 'rect' | 'line' | 'polyline' | 'polygon' | 'ellipse'
type IconNode = ReadonlyArray<readonly [Tag, Readonly<Record<string, string>>]>

/** Узлы Lucide 1.55.0: [тег, атрибуты]. Корневой svg задаёт компонент. */
const LUCIDE = {
  'layout-dashboard': [['rect', { width: '7', height: '9', x: '3', y: '3', rx: '1' }], ['rect', { width: '7', height: '5', x: '14', y: '3', rx: '1' }], ['rect', { width: '7', height: '9', x: '14', y: '12', rx: '1' }], ['rect', { width: '7', height: '5', x: '3', y: '16', rx: '1' }]],
  'list-checks': [['path', { d: 'M13 5h8' }], ['path', { d: 'M13 12h8' }], ['path', { d: 'M13 19h8' }], ['path', { d: 'm3 17 2 2 4-4' }], ['path', { d: 'm3 7 2 2 4-4' }]],
  'shopping-bag': [['path', { d: 'M16 10a4 4 0 0 1-8 0' }], ['path', { d: 'M3.103 6.034h17.794' }], ['path', { d: 'M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z' }]],
  'circle-ellipsis': [['circle', { cx: '12', cy: '12', r: '10' }], ['path', { d: 'M17 12h.01' }], ['path', { d: 'M12 12h.01' }], ['path', { d: 'M7 12h.01' }]],
  'wallet': [['path', { d: 'M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1' }], ['path', { d: 'M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4' }]],
  'megaphone': [['path', { d: 'M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z' }], ['path', { d: 'M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14' }], ['path', { d: 'M8 6v8' }]],
  'package': [['path', { d: 'M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z' }], ['path', { d: 'M12 22V12' }], ['polyline', { points: '3.29 7 12 12 20.71 7' }], ['path', { d: 'm7.5 4.27 9 5.15' }]],
  'message-square-text': [['path', { d: 'M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z' }], ['path', { d: 'M7 11h10' }], ['path', { d: 'M7 15h6' }], ['path', { d: 'M7 7h8' }]],
  'clipboard-list': [['rect', { width: '8', height: '4', x: '8', y: '2', rx: '1', ry: '1' }], ['path', { d: 'M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2' }], ['path', { d: 'M12 11h4' }], ['path', { d: 'M12 16h4' }], ['path', { d: 'M8 11h.01' }], ['path', { d: 'M8 16h.01' }]],
  'circle-check': [['circle', { cx: '12', cy: '12', r: '10' }], ['path', { d: 'm16 9-5.5 5.5L8 12' }]],
  'triangle-alert': [['path', { d: 'm21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3' }], ['path', { d: 'M12 9v4' }], ['path', { d: 'M12 17h.01' }]],
  'octagon-alert': [['path', { d: 'M12 16h.01' }], ['path', { d: 'M12 8v4' }], ['path', { d: 'M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z' }]],
  'receipt-russian-ruble': [['path', { d: 'M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z' }], ['path', { d: 'M8 11h5a2 2 0 0 0 0-4h-3v10' }], ['path', { d: 'M8 15h5' }]],
  'chevron-left': [['path', { d: 'm15 18-6-6 6-6' }]],
  'chevron-right': [['path', { d: 'm9 18 6-6-6-6' }]],
  'chevron-down': [['path', { d: 'm6 9 6 6 6-6' }]],
  'chevron-up': [['path', { d: 'm18 15-6-6-6 6' }]],
  'external-link': [['path', { d: 'M15 3h6v6' }], ['path', { d: 'M10 14 21 3' }], ['path', { d: 'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6' }]],
  'check': [['path', { d: 'M20 6 9 17l-5-5' }]],
  'x': [['path', { d: 'M18 6 6 18' }], ['path', { d: 'm6 6 12 12' }]],
  'lightbulb': [['path', { d: 'M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5' }], ['path', { d: 'M9 18h6' }], ['path', { d: 'M10 22h4' }]],
  'undo-2': [['path', { d: 'M9 14 4 9l5-5' }], ['path', { d: 'M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11' }]],
  'copy': [['rect', { width: '14', height: '14', x: '8', y: '8', rx: '2', ry: '2' }], ['path', { d: 'M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2' }]],
  'pencil': [['path', { d: 'M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z' }], ['path', { d: 'm15 5 4 4' }]],
  'refresh-cw': [['path', { d: 'M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8' }], ['path', { d: 'M21 3v5h-5' }], ['path', { d: 'M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16' }], ['path', { d: 'M8 16H3v5' }]],
  'loader-circle': [['path', { d: 'M21 12a9 9 0 1 1-6.219-8.56' }]],
  'star': [['path', { d: 'M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z' }]],
  'file-text': [['path', { d: 'M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z' }], ['path', { d: 'M14 2v5a1 1 0 0 0 1 1h5' }], ['path', { d: 'M10 9H8' }], ['path', { d: 'M16 13H8' }], ['path', { d: 'M16 17H8' }]],
  'history': [['path', { d: 'M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8' }], ['path', { d: 'M3 3v5h5' }], ['path', { d: 'M12 7v5l4 2' }]],
  'briefcase-business': [['path', { d: 'M12 12h.01' }], ['path', { d: 'M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2' }], ['path', { d: 'M22 13a18.15 18.15 0 0 1-20 0' }], ['rect', { width: '20', height: '14', x: '2', y: '6', rx: '2' }]],
  'calendar-clock': [['path', { d: 'M16 14v2.2l1.6 1' }], ['path', { d: 'M16 2v3' }], ['path', { d: 'M21 7.338V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h2.338' }], ['path', { d: 'M3 9h5.859' }], ['path', { d: 'M8 2v3' }], ['circle', { cx: '16', cy: '16', r: '6' }]],
  'key-round': [['path', { d: 'M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z' }], ['circle', { cx: '16.5', cy: '7.5', r: '.5', fill: 'currentColor' }]],
  'calculator': [['rect', { width: '16', height: '20', x: '4', y: '2', rx: '2' }], ['line', { x1: '8', x2: '16', y1: '6', y2: '6' }], ['line', { x1: '16', x2: '16', y1: '14', y2: '18' }], ['path', { d: 'M16 10h.01' }], ['path', { d: 'M12 10h.01' }], ['path', { d: 'M8 10h.01' }], ['path', { d: 'M12 14h.01' }], ['path', { d: 'M8 14h.01' }], ['path', { d: 'M12 18h.01' }], ['path', { d: 'M8 18h.01' }]],
  'percent': [['line', { x1: '19', x2: '5', y1: '5', y2: '19' }], ['circle', { cx: '6.5', cy: '6.5', r: '2.5' }], ['circle', { cx: '17.5', cy: '17.5', r: '2.5' }]],
  'wrench': [['path', { d: 'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.106-3.105c.32-.322.863-.22.983.218a6 6 0 0 1-8.259 7.057l-7.91 7.91a1 1 0 0 1-2.999-3l7.91-7.91a6 6 0 0 1 7.057-8.259c.438.12.54.662.219.984z' }]],
  'library': [['path', { d: 'm16 6 4 14' }], ['path', { d: 'M12 6v14' }], ['path', { d: 'M8 8v12' }], ['path', { d: 'M4 4v16' }]],
  'circle-help': [['circle', { cx: '12', cy: '12', r: '10' }], ['path', { d: 'M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3' }], ['path', { d: 'M12 17h.01' }]],
  'users': [['path', { d: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2' }], ['path', { d: 'M16 3.128a4 4 0 0 1 0 7.744' }], ['path', { d: 'M22 21v-2a4 4 0 0 0-3-3.87' }], ['circle', { cx: '9', cy: '7', r: '4' }]],
  'eye-off': [['path', { d: 'M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49' }], ['path', { d: 'M14.084 14.158a3 3 0 0 1-4.242-4.242' }], ['path', { d: 'M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143' }], ['path', { d: 'm2 2 20 20' }]],
  'download': [['path', { d: 'M12 15V3' }], ['path', { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' }], ['path', { d: 'm7 10 5 5 5-5' }]],
  'search': [['path', { d: 'm21 21-4.34-4.34' }], ['circle', { cx: '11', cy: '11', r: '8' }]],
  'power': [['path', { d: 'M12 2v10' }], ['path', { d: 'M18.4 6.6a9 9 0 1 1-12.77.04' }]],
  'smartphone': [['rect', { width: '14', height: '20', x: '5', y: '2', rx: '2', ry: '2' }], ['path', { d: 'M12 18h.01' }]],
  'lock': [['rect', { width: '18', height: '11', x: '3', y: '11', rx: '2', ry: '2' }], ['path', { d: 'M7 11V7a5 5 0 0 1 10 0v4' }]],
  'timer': [['line', { x1: '10', x2: '14', y1: '2', y2: '2' }], ['line', { x1: '12', x2: '15', y1: '14', y2: '11' }], ['circle', { cx: '12', cy: '14', r: '8' }]],
  'message-circle': [['path', { d: 'M7.9 20A9 9 0 1 0 4 16.1L2 22Z' }]],
  'send': [['path', { d: 'M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z' }], ['path', { d: 'm21.854 2.147-10.94 10.939' }]],
  'plus': [['path', { d: 'M5 12h14' }], ['path', { d: 'M12 5v14' }]],
} as const satisfies Record<string, IconNode>

export type LucideName = keyof typeof LUCIDE

/** Роль в интерфейсе → иконка Lucide (таблица из 06-icons.md). */
export const ICON_ROLE = {
  'tab-summary': 'layout-dashboard',
  'tab-actions': 'list-checks',
  'tab-products': 'shopping-bag',
  'tab-more': 'circle-ellipsis',
  'tab-ask': 'message-circle',
  'action-send': 'send',
  'action-new': 'plus',
  'agent-finance': 'wallet',
  'agent-ads': 'megaphone',
  'agent-stock': 'package',
  'agent-feedback': 'message-square-text',
  'agent-manager': 'clipboard-list',
  'status-good': 'circle-check',
  'status-attn': 'triangle-alert',
  'status-risk': 'octagon-alert',
  'status-fine': 'receipt-russian-ruble',
  'nav-back': 'chevron-left',
  'nav-next': 'chevron-right',
  'nav-expand': 'chevron-down',
  'nav-collapse': 'chevron-up',
  'nav-external': 'external-link',
  'action-confirm': 'check',
  'action-decline': 'x',
  'action-tip': 'lightbulb',
  'action-undo': 'undo-2',
  'action-copy': 'copy',
  'action-edit': 'pencil',
  'action-retry': 'refresh-cw',
  'action-busy': 'loader-circle',
  'content-rating': 'star',
  'section-reports': 'file-text',
  'section-history': 'history',
  'section-agents': 'briefcase-business',
  'section-schedule': 'calendar-clock',
  'section-key': 'key-round',
  'section-cost': 'calculator',
  'section-expenses': 'percent',
  'section-ops': 'wrench',
  'section-prompts': 'library',
  'section-help': 'circle-help',
  'section-access': 'users',
  'section-blind': 'eye-off',
  'section-export': 'download',
  'section-search': 'search',
  'section-timer': 'timer',
  'empty-agents-off': 'power',
  'empty-outside': 'smartphone',
  'empty-denied': 'lock',
} as const satisfies Record<string, LucideName>

export type IconName = keyof typeof ICON_ROLE
/** 16 — в тексте и плашках, 20 — в строках и кнопках, 24 — таббар и «назад», 32 — пустые состояния. */
export type IconSize = 16 | 20 | 24 | 32

export interface IconProps {
  name: IconName
  size?: IconSize
  /** Есть title → иконка значимая: role="img" + aria-label. Нет → декоративная: aria-hidden. */
  title?: string
  className?: string
}

export function Icon({ name, size = 20, title, className }: IconProps): React.JSX.Element {
  const node: IconNode = LUCIDE[ICON_ROLE[name]]
  const a11y = title !== undefined && title !== ''
    ? { role: 'img', 'aria-label': title }
    : { 'aria-hidden': true as const }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      // Штрих 2 в единицах сетки 24; на 32 px — 1,5, чтобы линия не толще 2 px.
      strokeWidth={size === 32 ? 1.5 : 2}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
      className={className === undefined ? 'ic' : 'ic ' + className}
      {...a11y}
    >
      {node.map(([tag, attrs], i) => createElement(tag, { key: i, ...attrs }))}
    </svg>
  )
}

// ── статусы: иконка своей формы + слово + цвет смысла ───────────────────────

/** Тон приходит с сервера вместе с готовой строкой; клиент его не вычисляет по знаку числа. */
export type Tone = 'good' | 'attn' | 'risk' | 'fine'

const STATUS: Record<Tone, { icon: IconName; word: string }> = {
  good: { icon: 'status-good', word: 'Хорошо' },
  attn: { icon: 'status-attn', word: 'Внимание' },
  risk: { icon: 'status-risk', word: 'Риск' },
  fine: { icon: 'status-fine', word: 'Штраф' },
}

/**
 * Метка статуса над пунктом: подложка смысла, иконка 16 и слово. Иконка тут декоративная — слово уже есть.
 * Скрытое двоеточие: диктор читает «Риск: выплата упала…» (04-voice, 3.12).
 */
export function StatusTag({ tone, word }: { tone: Tone; word?: string }): React.JSX.Element {
  const s = STATUS[tone]
  return (
    <span className={'tag tag-' + tone}>
      <Icon name={s.icon} size={16} />
      {word ?? s.word}
      <span className="vh">:</span>
    </span>
  )
}
